const ClaveRegimenAduanero = [
  {
    label: "Selecciona",
    value: "",
  },
  { value: "IMD", label: "Definitivo de importación. (Entrada)" },
  { value: "EXD", label: "Definitivo de exportación. (Salida)" },
  {
    value: "ITR",
    label:
      "Temporales de importación para retomar al extranjero en el mismo estado. (Entrada)",
  },
  {
    value: "ITE",
    label:
      "Temporales de importación para elaboración, transformación o reparación para empresas con programa IMMEX. (Entrada)",
  },
  {
    value: "ETR",
    label:
      "Temporales de exportación para retornar al país en el mismo estado. (Salida)",
  },
  {
    value: "ETE",
    label:
      "Temporales de exportación para elaboración, transformación o reparación. (Salida)",
  },
  { value: "DFI", label: "Depósito Fiscal. (Salida, Entrada)" },
  {
    value: "RFE",
    label:
      "Elaboración, transformación o reparación en recinto fiscalizado. (Salida, Entrada)",
  },
  { value: "RFS", label: "Recinto fiscalizado estratégico. (Salida, Entrada)" },
  { value: "TRA", label: "Tránsitos. (Salida, Entrada)" },
];

export default ClaveRegimenAduanero;
